import { BaseHttpError } from 'core/services/api/errors';
import { albumKeys } from 'core/utils/query-key-factory';
import { useServices } from 'core/services';
import { useQuery } from '@tanstack/react-query';
import { Album } from 'core/types';

export const useGetAlbums = (communityId: string) => {
	const { api, authentication } = useServices();

	const isLoggedIn = authentication.isAuthenticated();

	const albumsQuery = useQuery<Album[], BaseHttpError>({
		queryKey: albumKeys.list(communityId),
		queryFn: () => {
			return api.getAlbums(communityId).then(response =>
				response.data.albums.map(album => ({
					...album,
					photos: [],
				}))
			);
		},
		enabled: !!communityId && isLoggedIn,
		placeholderData: previousData => previousData,
	});

	return albumsQuery;
};
